<mat-toolbar>
    <button matIconButton [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
        <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
        @if(false){
        <a mat-menu-item (click)="onNavigateInstructions()">
            <mat-icon>home</mat-icon>
            <span>Instructions</span>
        </a>
        }
        <a mat-menu-item (click)="onNavigateToSimpleCounter()">
            <mat-icon>view_headline</mat-icon>
            <span>Simple Counter</span>
        </a>
        <a mat-menu-item (click)="onNavigateToCountdownTimer()">
            <mat-icon>timer</mat-icon>
            <span>Countdown Timer</span>
        </a>
        <a mat-menu-item (click)="onNavigateQr()">
            <mat-icon>qr_code</mat-icon>
            <span>QR Code</span>
        </a>
        <a mat-menu-item (click)="onInstallFirmware()">
            <mat-icon>update</mat-icon>
            <span>Update Firmware</span>
        </a>
    </mat-menu>
  <span>Pedal Questionable Codes</span>
  <span class="spacer"></span>
  <button (click)="onConnectToPedal()" matIconButton class="example-icon favorite-icon" aria-label="Example icon-button with heart icon">
    @if(pedalService.connected()){
        <mat-icon class="connected">bluetooth_connected</mat-icon>
    } @else { 
        <mat-icon class="disconnected">bluetooth</mat-icon>
    }
  </button>
  @if(canShare()){
  <button (click)="onShareLink()" matIconButton class="example-icon" aria-label="Example icon-button with share icon">
    <mat-icon>share</mat-icon>
  </button>
}
</mat-toolbar>
